import { render, staticRenderFns } from "./Bbhome.vue?vue&type=template&id=89178c4e&scoped=true"
import script from "./Bbhome.vue?vue&type=script&lang=js"
export * from "./Bbhome.vue?vue&type=script&lang=js"
import style0 from "./Bbhome.vue?vue&type=style&index=0&id=89178c4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89178c4e",
  null
  
)

export default component.exports